<div #container class="template-host"></div>
@if (warningMessage(); as message) {
  <div class="error-message">
    <mat-icon svgIcon="icon_warning_24" />
    <span>{{ message }}</span>
  </div>
}
